/**
 *  Init carousel for product-reviews
 */
const initCarousel = () => {
    const $reviews = $(".js-product-review");

    if ($reviews.length > 0) {
        $reviews.each(function () {
            const $this = $(this);

            $this.slick({
                slidesToShow: 1,
                pauseOnFocus: false,
                mobileFirst: true,
                arrows: true,
                adaptiveHeight: true,
                dots: false,
                infinite: false
            });
        });
    }
};

initCarousel();

